export default __webpack_public_path__ + "static/media/icon-download.7b317c47.svg";